import { createAction, props } from '@ngrx/store';

export type SnackbarVerticalPosition = 'top' | 'bottom';
export type SnackbarHorizontalPosition = 'start' | 'center' | 'end' | 'left' | 'right';

export const showSnackbar = createAction(
  '[Snackbar] show',
  props<{ payload: { message: string } }>(),
);
